import pdf from './pdf.svg'
import zip from './zip.svg'
import doc from './doc.svg'
import xls from './xls.svg'
import jpg from './jpg.svg'

const extensions: Record<string, string> = {
  pdf,
  zip,
  doc,
  docx: doc,
  xls,
  xlsx: xls,
  jpg,
}

export { extensions }
